import BookmarkIcon from "@heroicons/react/24/solid/BookmarkIcon";
import ChevronLeftIcon from "@heroicons/react/24/solid/ChevronLeftIcon";
import ChevronRightIcon from "@heroicons/react/24/solid/ChevronRightIcon";
import SparklesIcon from "@heroicons/react/24/solid/SparklesIcon";
import { Box, ButtonBase } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Link from "next/link";
import { Swiper } from "swiper/react";
import Color from "../../../assets/colors";

export const TitleStyled = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "25px",
  fontFamily: "Inter",
  fontWeight: 700,
  lineHeight: "32px",
  textAlign: "center",

  span: {
    color: Color.hiredlyPurple,
    fontSize: "40px",
    lineHeight: "32px",
    fontWeight: 400,
  },

  ...(props?.type == "subtitle" && {
    color: "rgba(0, 0, 0, 0.60)",
    fontFamily: "Inter",
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: 500,
    textAlign: "center",
  }),

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "32px",
    fontFamily: "Georgia",
    fontWeight: 400,
    lineHeight: "32px",
    textAlign: "center",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "32px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    fontFamily: "Georgia",
    fontWeight: 400,
    lineHeight: "32px",
    textAlign: "center",

    span: {
      color: Color.hiredlyPurple,
      fontSize: "24px",
      lineHeight: "32px",
      fontWeight: 400,
    },

    ...(props?.type == "subtitle" && {
      fontFamily: "Inter",
      fontSize: "12px",
      lineHeight: "24px",
      fontWeight: 500,
      textAlign: "center",
    }),
  },
}));

export const SwiperStyled = styling(Swiper)((props) => ({
  width: "100%",
  overflow: "hidden",

  "& .swiper-wrapper": {
    transitionTimingFunction: "linear",
  },

  "& .swiper-slide": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "auto",
  },
}));

export const LogoContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "80px",
  padding: "12px",
  minWidth: "144px",

  cursor: "pointer",

  [props.theme.breakpoints.down("lg")]: {
    height: "70px",
    padding: "10px",
    minWidth: "120px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "60px",
    padding: "8px",
    minWidth: "100px",
  },
}));

export const LogoStyled = styling("img")((props) => ({
  height: "100%",
  objectFit: "contain",
  maxWidth: "120px",
  maxHeight: "60px",
  backgroundSize: "contain",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "50px",
    maxWidth: "100px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "40px",
    maxWidth: "80px",
  },
}));

export const TitleContainer = styling(Grid)((props) => ({
  margin: "0px",

  [props.theme.breakpoints.down("tablet")]: {
    margin: "0px",
  },
}));

export const TrustedCompanyGrid = styling(Grid)((props) => ({
  padding: "80px 100px",
  gap: "30px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "40px 24px",
    gap: "20px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 16px",
    gap: "15px",
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  // maxWidth: "1220px",
  // padding: "0px 200px",
  height: "100%",
  maxWidth: "1240px",

  [props.theme.breakpoints.down("lg")]: {
    // maxWidth: "720px",
    padding: "0px 0px",
  },

  // [props.theme.breakpoints.down("tablet")]: {
  //   maxWidth: "100%",
  // },
}));

export const CompanyButtons = styling("a")((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0,
  borderRadius: "16px",
  border: "1px solid #D8D8D8",
  background: "#F7F7FF",
  alignContent: "center",

  "&:hover": {
    border: "1px solid #512ACC",
  },

  [props.theme.breakpoints.down("lg")]: {},

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const FlexContainer = styling(Box)({
  display: "flex",
  width: "100%",
});

export const TextStyled = styling(Typography)({});

export const SectionContainer = styling("section")({
  maxWidth: "1240px",
  width: "100%",
  padding: "40px 0px 80px 0px",
  margin: "0 auto",

  "@media (max-width: 1280px)": {
    padding: "0 24px",
    margin: "24px auto 24px auto",
  },

  "@media (max-width: 640px)": {
    padding: "0px 24px",
    margin: "0px auto 24px auto",
  },
});

export const ButtonStyled = styling(ButtonBase)({
  background: Color.white,
  borderRadius: "32rem",
  border: `1px solid ${Color.black}`,
  width: "2.3125rem",
  height: "2.3125rem",

  transition: "all 0.075s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      border: `1px solid ${Color.black}`,
      boxShadow: "2px 2px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-2px, -2px)",
      cursor: "pointer",
    },
  },

  "&:disabled": {
    opacity: "0.25",
    cursor: "none",
  },
});

export const ArrowRightIconStyled = styling(ChevronRightIcon)({
  height: "1.5rem",
  width: "1.125rem",
  marginLeft: "0.125rem",
});

export const ArrowLeftIconStyled = styling(ChevronLeftIcon)({
  height: "1.5rem",
  width: "1.125rem",
});

export const JobContainer = styling("div")({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gridTemplateRows: "repeat(1, 1fr)",
  gap: "40px",
  width: "100%",

  "@media (max-width: 1280px)": {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "40px",
    width: "100%",
  },

  "@media (max-width: 640px)": {
    display: "flex",
    gap: "8px",
    flexDirection: "column",
  },

  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export const PaginationContainer = styling("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "0.5rem",
  marginTop: "1rem",
});

export const PaginationButton = styling("div")({
  border: `1px solid ${Color.black}`,
  borderRadius: "25rem",
  width: "15px",
  height: "15px",

  transition: "all 0.15s ease-in-out",
});

export const JobCard = styling(Link)({
  alignSelf: "stretch",
  background: Color.white,
  borderRadius: "10px",
  outline: "1px solid #D8D8D8",
  outlineOffset: "-1px",
  width: "100%",
  padding: "16px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "20px",

  textDecoration: "none",

  transition:
    "box-shadow 0.1s ease-in-out, transform 0.1s ease-in-out, outline 0.1s ease-in-out",

  "@media (min-width: 1280px)": {
    "&:hover": {
      outline: `1px solid ${Color.black}`,
      boxShadow: "4px 4px 0px rgba(0, 0, 0, 1)",
      transform: "translate(-4px, -4px)",
    },
  },
});

export const JobInfoChip = styling("div")({
  background: Color.backgroundGrey,
  color: "rgba(0, 0, 0, 0.60)",
  borderRadius: "0.25rem",

  fontSize: "0.625rem",
  fontWeight: "700",

  padding: "0.25rem 0.62rem",
});

export const HighlightChip = styling("div")({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",

  background: Color.lightHiredlyPurple,
  color: Color.darkPurple,
  border: `1px solid ${Color.darkPurple}`,
  borderRadius: "0.25rem",

  fontSize: "0.625rem",
  fontWeight: "400",
  letterSpacing: "0.09375rem",

  padding: "0.125rem 0.3rem",
});

export const SparklesIconStyled = styling(SparklesIcon)({
  width: "0.625rem",
  height: "0.625rem",
});

export const CompanyLogo = styling("img")({
  width: "48px",
  height: "48px",
  padding: "1px",
  borderRadius: "8px",
  background: Color.white,
  border: "1px solid #D8D8D8",
  objectFit: "contain",
  userSelect: "none",

  transition: "all 0.1s ease-in-out",
});

export const BookmarkIconStyled = styling(BookmarkIcon)({
  color: Color.white,
  strokeWidth: "1.5px",
  transition: "all 0.1s ease-in-out",

  "&:hover ": {
    strokeWidth: "3px",
    cursor: "pointer",
  },
});

export const BookmarkFilledIconStyled = styling(BookmarkIcon)({
  color: Color.hiredlyPurple,
  strokeWidth: "1.5px",
  transition: "all 0.1s ease-in-out",

  "&:hover ": {
    strokeWidth: "3px",
    cursor: "pointer",
  },
});
export const CircularProgressStyled = styling(CircularProgress)({});
